import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  leftIconContainer: {
    width: 32,
  },
  actionsContainer: {
    marginLeft: 10,
    minWidth: "78px",
  },
  title: {
    flex: 1,
  },
  rowItem: {
    paddingLeft: 10,
    paddingRight: 10,
    marginBottom: 0,
    height: 50,
    "&:hover": {
      "& span": {
        opacity: 1,
      },
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      height: "auto",
      marginBottom: 20,
    },
  },
}));

const DirectMessageRowItem = ({
  title,
  subTitle,
  leftIcon,
  privacyIcon,
  handleOpenPrivacySetting,
  name,
  hideActionButtons,
  visibility,
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" className={classes.rowItem}>
      <Box alignItems="center" className={classes.leftIconContainer}>
        <span>{leftIcon}</span>
      </Box>
      <Box display="flex" flexDirection="column" className={classes.title}>
        <span>
          <span>
            <Typography style={{ fontSize: 14 }}>
              <span>
              </span>{" "}
              {title}
            </Typography>
          </span>
        </span>
        <div>
          {hideActionButtons ? (
            <Typography style={{ fontSize: 12, color: "rgba(0,0,0,0.55)" }}>
              {subTitle}
            </Typography>
          ) : (
            <div>
              <div>
                <Typography
                  style={{
                    fontSize: 12,
                    color: "rgba(0,0,0,0.55)",
                  }}
                >
                  {subTitle}
                </Typography>
              </div>
            </div>
          )}
        </div>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        className={classes.actionsContainer}
      >
        {!hideActionButtons && (
          <div>
            <IconButton
              onClick={() => handleOpenPrivacySetting({ name, visibility })}
              sx={{ minWidth: "40px" }}
            >
              {privacyIcon}
            </IconButton>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default DirectMessageRowItem;

DirectMessageRowItem.defaultProps = {
  name: "",
  hideActionButtons: false,
  visibility: "",
  title: undefined,
};

DirectMessageRowItem.propTypes = {
  leftIcon: PropTypes.node.isRequired,
  handleOpenPrivacySetting: PropTypes.func.isRequired,
  privacyIcon: PropTypes.node.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.node.isRequired,
  name: PropTypes.node,
  hideActionButtons: PropTypes.bool,
  visibility: PropTypes.string,
};
